import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { User } from '@app/_models';
import { headervalue } from 'src/headervalue/header';

// const httpOptions = {
//     headers: new HttpHeaders({ 'Content-Type': 'application/json' })
// };

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }



    signin(username: string, password: string) {
        // const reqHeader = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json')
        // console.log("reqHeader"+reqHeader)
        //return this.http.post<any>(`${environment.apiUrl}/users/authenticate`, { username, password })
        const reqHeaderq = headervalue;
        return this.http.post<any>(`${environment.apiUrl}/auth/signin`, { username, password }, { headers: new HttpHeaders(headervalue.header) })
            //return this.http.get<boolean>(`${environment.apiUrl}/auth/signin`+ '/' + username+ '/' + password )
            .pipe(map(user => {

                if (user.respMessage === "Success") {
                    // store user details and basic auth credentials in local storage to keep user logged in between page refreshes
                    // user.authdata = window.btoa(username + ':' + password);
                    user.token = user.respData.accessToken;
                    localStorage.setItem('token', user.respData.accessToken);
                    localStorage.setItem('refreshToken', user.respData.refreshToken);
                    
                    this.currentUserSubject.next(user);

                     this.startRefreshTokenTimer();
                } return user;
            }));
        // .pipe(
        //   //  retry(2),
        //   //  catchError(e=>throwError(this.errorHandler(e)))
        //   catchError(this.handleError)
        // )     
    }

    errorHandler(error) {
        console.log(error);
    }

    handleError(error: HttpErrorResponse) {
        console.log("lalalalalalalala");
        return throwError(error);
    }

    resetPassword1(UserEmail: string) {

        // return this.http.post<any>(`${environment.apiUrl}/auth/resetPassword`, { UserEmail })
        return this.http.post<any>(`${environment.apiUrl}/auth/resetPassword` + '/' + UserEmail, headervalue.header)
            .pipe(map(user => {
                // store user details and basic auth credentials in local storage to keep user logged in between page refreshes
                return user;
            }));
    }

    resetPassword(UserEmail: string) {
        return this.http.post(`${environment.apiUrl}/auth/resetPassword` + '/' + UserEmail, headervalue.header).pipe(catchError(this.handleError));
    }

    logoutVeri() {
        var UserRole = localStorage.getItem('role');
        var userId = localStorage.getItem('user_id');

        // app.component.ts calls logout() defensively on page load whenever the
        // token is missing or the URL's role doesn't match the stored role - in
        // those cases there's no real session to report, so skip the call
        // instead of hitting the backend with a literal ".../logout/null/..." URL.
        if (!userId) {
            return of(null);
        }

        return this.http.post(`${environment.apiUrl}/auth/logout` + '/' + userId + '/' + UserRole, headervalue.header).pipe(catchError(this.handleError));

    }

    GetMenuByRole( roleId) {
        var temp = this.http.get<any>(`${environment.apiUrl}/DashBoardAccess/getAllTabs/` +roleId, { headers: new HttpHeaders(headervalue.headerWithJwt) });
        return temp;
    }


    logout() {

        //     // remove user from local storage to log user out
        // localStorage.removeItem('currentUser');
        // localStorage.removeItem('currentRole');
        // localStorage.removeItem('token');
        // localStorage.removeItem('user_id');
        // localStorage.removeItem('userName');
        this.currentUserSubject.next(null);

       //this.stopRefreshTokenTimer();
    }


    // //Refresh Token
    refreshToken() {

     
        console.log('==================refreshToken===============');


        var refreshToken = localStorage.getItem('refreshToken');
        return this.http.post<any>(`${environment.apiUrl}/auth/refreshtoken`, { refreshToken })
            .pipe(map((user) => {
                this.currentUserSubject.next(user);
                this.startRefreshTokenTimer();
                console.log('token', user.token);
                localStorage.setItem('token', user.token);
                return user;
            }));
    }

    private refreshTokenTimeout;

    private startRefreshTokenTimer() {
        // parse json object from base64 encoded jwt token
        const jwtToken = JSON.parse(atob(this.currentUserValue.token.split('.')[1]));


        console.log("==============startRefreshTokenTimer===========");

        // set a timeout to refresh the token a minute before it expires
        // const expires = new Date(jwtToken.exp * 1000);
        /*const expires = new Date(jwtToken.exp * 1000);
        console.log('expires', expires);
        const timeout = expires.getTime() - Date.now() - (60 * 1000);
        console.log('timeout', timeout);
        */
        const timeout = ((jwtToken.exp - jwtToken.iat)*1000);
      
        console.log("==============startRefreshTokenTimer=======timeout====",timeout);

        this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
    }

    private stopRefreshTokenTimer() {
      //  clearTimeout(this.refreshTokenTimeout);
    }

}